import { withMetadata } from '../metadata'
import { isPossiblePhoneNumber as _isPossiblePhoneNumber } from '../../core/index'

export function isPossiblePhoneNumber() {
	return withMetadata(_isPossiblePhoneNumber, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/min/exports/isPossiblePhoneNumber.js
// module id = 640
// module chunks = 214